import './LessonList.less';
import React from 'react';
import {Link} from "react-router-dom";
import routes from "../../../../routing/routes";
import LessonIcon from "../../../../widgets/lesson-icon/LessonIcon";


export default function LessonList({lessons, currentLessonId}) {

    return <ul className="lesson-list">
        {
            lessons.map(lesson => {
                return <li key={lesson.id}>
                    <Link
                        to={routes.learning.getUrl(lesson.course_id, lesson.id)}
                        className={`${currentLessonId === lesson.id ? 'selected' : ''}`}
                    >
                        <div className="icon-holder">
                            <LessonIcon lesson={lesson}/>
                        </div>
                        <div className="lesson-name">{lesson.name}</div>
                    </Link>
                </li>;
            })
        }
    </ul>;
}
